import { GlobalObject } from '../utils/GlobalObject';
import { Boardcaster } from './../event/Boadcaster';

export class MockFancilityState {
    private fancilityData: any;
    constructor() {
        if (!this.fancilityData) {
            this.initMockdata();
            GlobalObject.getInstance().setFancilityData(this.fancilityData);
        }
    }
    private initMockdata() {
        this.fancilityData = [
            {
                "wostatusname": "正常",
                "macno": "018-010"
            },
            {
                "wostatusname": "关机",
                "macno": "018-011"
            },
            {
                "wostatusname": "待机",
                "macno": "026-040"
            },
            {
                "wostatusname": "维修中",
                "macno": "045-009"
            },
            {
                "wostatusname": "待机",
                "macno": "045-020"
            },
            {
                "wostatusname": "正常",
                "macno": "045-022"
            },
            {
                "wostatusname": "关机",
                "macno": "045-040"
            },
            {
                "wostatusname": "待机",
                "macno": "045-046"
            },
            {
                "wostatusname": "维修中",
                "macno": "045-049"
            },
            {
                "wostatusname": "关机",
                "macno": "045-061"
            },
            {
                "wostatusname": "报警",
                "macno": "045-062"
            },
            {
                "wostatusname": "加工",
                "macno": "045-065"
            },
            {
                "wostatusname": "待机",
                "macno": "045-094"
            },
            {
                "wostatusname": "报警",
                "macno": "045-096"
            },
            {
                "wostatusname": "加工",
                "macno": "074-009"
            },
            {
                "wostatusname": "报警",
                "macno": "074-010"
            },
            {
                "wostatusname": "正常",
                "macno": "097-011"
            },
            {
                "wostatusname": "正常",
                "macno": "099-036"
            },
            {
                "wostatusname": "正常",
                "macno": "083-083"
            },
            {
                "wostatusname": "关机",
                "macno": "029-059"
            },
            {
                "wostatusname": "加工",
                "macno": "029-055"
            },
            {
                "wostatusname": "正常",
                "macno": "029-056"
            },
            {
                "wostatusname": "正常",
                "macno": "075-003"
            },
            {
                "wostatusname": "正常",
                "macno": "031-042"
            },
            {
                "wostatusname": "加工",
                "macno": "029-057"
            },
            {
                "wostatusname": "正常",
                "macno": "029-058"
            },
            {
                "wostatusname": "正常",
                "macno": "081-001"
            },
            {
                "wostatusname": "待机",
                "macno": "016-280"
            },
            {
                "wostatusname": "待机",
                "macno": "016-281"
            },
            {
                "wostatusname": "待机",
                "macno": "016-282"
            },
            {
                "wostatusname": "正常",
                "macno": "016-283"
            },
            {
                "wostatusname": "正常",
                "macno": "016-284"
            },
            {
                "wostatusname": "正常",
                "macno": "045-077"
            },
            {
                "wostatusname": "报警",
                "macno": "045-078"
            },
            {
                "wostatusname": "关机",
                "macno": "045-079"
            },
            {
                "wostatusname": "报警",
                "macno": "045-080"
            },
            {
                "wostatusname": "正常",
                "macno": "045-081"
            },
            {
                "wostatusname": "正常",
                "macno": "045-082"
            },
            {
                "wostatusname": "正常",
                "macno": "045-083"
            },
            {
                "wostatusname": "正常",
                "macno": "045-084"
            },
            {
                "wostatusname": "报警",
                "macno": "045-085"
            },
            {
                "wostatusname": "正常",
                "macno": "045-086"
            },
            {
                "wostatusname": "正常",
                "macno": "045-087"
            },
            {
                "wostatusname": "报警",
                "macno": "045-088"
            },
            {
                "wostatusname": "加工",
                "macno": "045-089"
            },
            {
                "wostatusname": "正常",
                "macno": "045-066"
            },
            {
                "wostatusname": "关机",
                "macno": "045-090"
            },
            {
                "wostatusname": "报警",
                "macno": "045-091"
            },
            {
                "wostatusname": "关机",
                "macno": "045-092"
            },
            {
                "wostatusname": "加工",
                "macno": "045-093"
            },
            {
                "wostatusname": "正常",
                "macno": "058-006"
            },
            {
                "wostatusname": "正常",
                "macno": "061-007"
            },
            {
                "wostatusname": "待机",
                "macno": "061-026"
            },
            {
                "wostatusname": "待机",
                "macno": "061-029"
            },
            {
                "wostatusname": "正常",
                "macno": "045-067"
            },
            {
                "wostatusname": "正常",
                "macno": "061-030"
            },
            {
                "wostatusname": "关机",
                "macno": "061-031"
            },
            {
                "wostatusname": "正常",
                "macno": "061-032"
            },
            {
                "wostatusname": "关机",
                "macno": "061-033"
            },
            {
                "wostatusname": "正常",
                "macno": "061-034"
            },
            {
                "wostatusname": "关机",
                "macno": "061-036"
            },
            {
                "wostatusname": "正常",
                "macno": "061-037"
            },
            {
                "wostatusname": "正常",
                "macno": "045-068"
            },
            {
                "wostatusname": "正常",
                "macno": "045-069"
            },
            {
                "wostatusname": "报警",
                "macno": "045-070"
            },
            {
                "wostatusname": "正常",
                "macno": "061-038"
            },
            {
                "wostatusname": "正常",
                "macno": "045-071"
            },
            {
                "wostatusname": "正常",
                "macno": "063-004"
            },
            {
                "wostatusname": "正常",
                "macno": "045-072"
            },
            {
                "wostatusname": "正常",
                "macno": "063-008"
            },
            {
                "wostatusname": "正常",
                "macno": "067-032"
            },
            {
                "wostatusname": "正常",
                "macno": "067-060"
            },
            {
                "wostatusname": "正常",
                "macno": "045-073"
            },
            {
                "wostatusname": "正常",
                "macno": "045-074"
            },
            {
                "wostatusname": "故障",
                "macno": "045-075"
            },
            {
                "wostatusname": "故障",
                "macno": "045-076"
            },
            {
                "wostatusname": "故障",
                "macno": "067-061"
            },
            {
                "wostatusname": "维修中",
                "macno": "067-062"
            },
            {
                "wostatusname": "维修中",
                "macno": "067-073"
            }

        ]
    }
    public updata() {
        let msg = { type: Boardcaster.getInstance().OPEN_FACILITY, data: {msg:"我来拿设备状态信息。"} }
        //console.log("MockFancilityState update",msg);
        Boardcaster.getInstance().send(msg);
    }
}